module.exports = __webpack_public_path__ + "media/explanation.3fcdc2ac.mp4";